import qs from 'qs'
import React from 'react'
import { Link } from 'react-router-dom'
import request from '../../../request'

export default class Companies extends React.Component {
  constructor() {
    super()
    this.state = {
      companies: JSON.parse(localStorage.getItem('companies')) || { data: [] },
    }
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate(nextProps) {
    if(nextProps.location.search !== this.props.location.search) this.load()
  }

  async load() {
    let { location } = this.props
    let query = qs.parse(location.search.substring(1))
    let page = parseInt(query.page || 1, 10)
    
    try {
      if(this.state.companies.data.length === 0) this.setState({ loading: true })
      let companies = await request({ url: `admin/companies?page=${page}` })
      localStorage.setItem('companies', JSON.stringify(companies))
      this.setState({ companies, loading: false })
    }
    catch(e) {
      console.error(e)
      this.setState({ loading: false })
    }
  }

  render() {
    let { location } = this.props
    let { companies, loading } = this.state
    let query = qs.parse(location.search.substring(1))
    let page = parseInt(query.page || 1, 10)

    return (
      <div style={{ opacity: loading ? .5 : 1 }}>
        <table>
          <thead>
            <tr>
              <th className="company_settings">Company</th>
              <th className="email">Email</th>
              <th className="location">Location</th>
              <th className="actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {companies.data.map(company => (
              <tr key={company.id}>
                <td className="company_settings">{company.name}</td>
                <td className="email">{company.email}</td>
                <td className="location">{company.city}, {company.state}</td>
                <td className="actions">
                  <Link  to={`/settings/companies/${company.id}/users`}>Users</Link> · <Link  to={`/settings/companies/${company.id}/edit`}>Edit</Link> · <Link  to={{ pathname: `/settings/companies/${company.id}/delete`, state: { company }}}>Delete</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {companies.prev_page_url ?
          <Link 
            className="prev-button"
            to={`/settings/companies?page=${page - 1}`}
          >
            Previous Page
          </Link>
        :
          null
        }

        {companies.next_page_url ?
          <Link 
            className="next-button"
            to={`/settings/companies?page=${page + 1}`}
          >
            Next Page
          </Link>
        :
          null
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/views/settings/companies/all.js